<template>
  <div class="content-subject-matrix">
    <div class="content-matrix-10num" v-for="(option, index) in question.subjects" v-bind:key="index">
      <div class="subject-matrix">
        <image-viewer
          v-if="question.imageOnTitle && question.imageOnTitle.length > index && question.showImageOnTitle"
          :image="question.imageOnTitle[index]"
          position="middle"
          :question-type="question.type"
          :show-image-on-title="question.showImageOnTitle"
        />
        <div class="subject-label" v-if="!question.showImageOnTitle || (!question.hideAllSubjectLabels && question.showImageOnTitle)">
          <span :style="colors.splashColor" v-html="replaceMeta(option.label)"></span>
        </div>
        <div class="subject-rating">
          <div class="subject-rating-content">
            <app-form-rate-active
              v-model="inputValue"
              :splitButtons="question.layout.splitButtons"
              :items="items"
              item-value="id"
              item-text="id"
              :textColor="colors.actionText"
              :bgColor="colors.actionColor"
              :hoverColor="colors.buttonHover"
              @rate-value="updateValue($event,option._id)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { replaceMetadata } from '../../_helpers/metadata'
import ImageViewer from '@/components/common/ImageViewer.vue'

export default {
  name: 'matrix10num',
  props: ['question', 'colors'],
  components: {
    'app-form-rate-active': () => import('@binds-tech/binds-design-system/src/components/Form/RateActive'),
    ImageViewer
  },
  data () {
    return {
      inputValue: '',
      value: [],
      valueCheck: [],
      items: [
        { id: 0, value: 0 },
        { id: 1, value: 10 },
        { id: 2, value: 20 },
        { id: 3, value: 30 },
        { id: 4, value: 40 },
        { id: 5, value: 50 },
        { id: 6, value: 60 },
        { id: 7, value: 70 },
        { id: 8, value: 80 },
        { id: 9, value: 90 },
        { id: 10, value: 100 }
      ]
    }
  },
  create () {
    // seta tradução da question
    if (this.question.language) {
      this.$i18n.locale = this.question.language
    }
  },
  mounted () {
    this.question.subjects.forEach(item => {
      this.value.push({ _id: item._id })
    })

    this.$root.$on('footer-submit', payload => {
      if (payload) {
        this.submit()
      }
    })
  },
  computed: {
    questionsList () {
      const qs = this.$store.getters['question/getQuestion']
      return qs
    },
    metadata () {
      let data
      if (!this.isPreview) {
        data = this.$store.getters['seedData/getSeedData']
      } else {
        data = this.$store.getters['preview/getSeedData']
      }

      const metadata = data && data.metadata ? data.metadata : {}
      return metadata
    }
  },
  methods: {
    updateValue (rating, id) {
      const optionIndex = this.value.findIndex(item => item._id === id)
      if (optionIndex > -1) {
        if (this.value[optionIndex].rating) {
          this.value[optionIndex].rating = rating
          this.valueCheck[optionIndex].rating = rating
        } else {
          this.value[optionIndex].rating = rating
          this.valueCheck.push(this.value[optionIndex])
        }
      }
      if (this.question.required) {
        this.valueCheck.length >= this.value.length ? this.$root.$emit('show-btn', true) : this.$root.$emit('show-btn', false)
      }
    },
    submit () {
      const send = this.value
      const answeredOptionsCount = this.value.filter(item => {
        return item.rating !== undefined
      })
      let submitSubjects = {}
      answeredOptionsCount.length > 0 ? submitSubjects = { value: send } : submitSubjects = { skip: true }
      this.$emit('value-changed', submitSubjects)
      this.$emit('question-answered', true)
      this.$root.$emit('refresh-footer')
    },
    replaceMeta (str) {
      return replaceMetadata(str, this.metadata, this.answersList)
    }
  }
}
</script>
<style lang="scss">
.content-subject-matrix {
  .content-matrix-10num {
    width: 550px;
    .subject-matrix {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 15px 0;

      .image-viewer-container {
        margin-bottom: 20px;
        width: 98%;
        display: flex;
        justify-content: center;
      }

      .subject-label {
        width: v-bind('question.layout.splitButtons ? "85%" : "98%"');
        margin-bottom: 10px;
        span {
          overflow-wrap: break-word;
          color: var(--splashColor);
        }
      }
    }
  }
}
// Responsivity to mobile
@media only screen and (max-width: 800px) {
  .content-subject-matrix {
    flex-direction: column;
    .content-matrix-10num {
      width: 100%;
      .subject-matrix {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin: 15px 0;
        .subject-rating-content {
          display: flex;
          align-items: center;
          justify-content: center;
          .subject-rating {
            width: 100%;
          }
        }

        .image-viewer-container {
          margin-bottom: 15px;
          width: 97%;
        }
      }
    }
  }
}

@media only screen and (max-width: 395px) {
  .content-subject-matrix {
    .content-matrix-10num {
      .subject-label {
        width: 97% !important;
      }
      .subject-matrix {
        .image-viewer-container {
          margin-bottom: 12px;
        }
      }
    }
  }
}
</style>
